import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGetPolicyInfo } from "utils/API/TrxNowAPI";
import { PolicyLookupSpinner } from "webapp/components/PolicyLookupSpinner";
import { devLog } from "utils/devLog";

const policyMap = new Map();
export default function TDMemberInformationForm(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchValue, setSearchValue] = useState(props.currState.MemberLookup.memberRef);
  const [firstName, setFirstName] = useState(props.currState.MemberLookup.firstName);
  const [lastName, setLastName] = useState(props.currState.MemberLookup.lastName);
  const [postalCode, setPostalCode] = useState(props.currState.MemberLookup.postalCode);
  const [bankCardNumber, setBankCardNumber] = useState(props.currState.MemberLookup.bankCardNumber);
  const [phoneNumber, setPhoneNumber] = useState(props.currState.MemberLookup.phoneNumber);

  const [searchType, setSearchType] = useState(props.currState.MemberLookup.searchType);
  const [accounts, setAccounts] = useState(undefined);
  const [contacts, setContacts] = useState([]);
  const [contactToDisplay, setContactToDisplay] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedAccount, setSelectedAccount] = useState(null);

  const [showAddNew, setShowAddNew] = useState(false);
  const [newSelect, setNewSelect] = useState(false);
  const [partnerCode, setPartnerCode] = useState(props.currState.localGroup);

  useEffect(() => {
    // devLog(props);
    setSelectedContact("");
    setSelectedAccount("");
    setContactToDisplay(undefined);
    onSubmit();
    setNewSelect(false);
    setShowAddNew(false);
  }, []);

  const onLoad = (success) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(success);
    }
  };

  const onSelect = (sa, sc) => {
    if (typeof props.onUserSelect === "function") {
      props.onUserSelect(sa, sc);
    }
  };

  const onSelectContact = (sc) => {
    setSelectedContact(sc);
    // setShowAddNew(false);
    // setNewSelect(false);
    onSelect(selectedAccount, sc);
  };

  const onSelectAccount = (sa) => {
    setSelectedAccount(sa);
    setSelectedContact(null);
    setContactToDisplay(sa.contacts);
    // setShowAddNew(false);
    // setNewSelect(false);
    onSelect(sa, null);
  };

  // const contactDisplay = (contacts) => {
  //   let cons = [];
  //   if (typeof accounts === "undefined" || !contacts) {
  //     return;
  //   }

  //   contacts.map((con, index) => {
  //     if (con.accountRef === selectedAccount.accountRef) {
  //       cons.push(con);
  //     }
  //   });
  //   setContactToDisplay(cons);
  // };

  useEffect(() => {
    // contactDisplay(contacts);
    setSelectedContact(null);
    setShowAddNew(false);
    setNewSelect(false);
  }, [selectedAccount]);

  const onSubmit = (e) => {
    setError("");

    if (policyMap.has(searchValue)) {
      setAccounts(policyMap.get(searchValue));
      setLoading(false);
      onLoad(true);
      return;
    }

    setLoading(true);
    //Lookup: Callout
    apiGetPolicyInfo({
      data: {
        providerRef: props.currState.providerRef,
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        postalCode: postalCode,
        bankCardNumber: bankCardNumber,
        searchType: searchType,
        partnerCode: partnerCode,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      //Lookup: Success
      .then((json) => {
        // devLog("JSON", json);
        if (typeof json.data.memberInfos === "object" && json.data.memberInfos !== null) {
          if (!json.data.error) {
            // devLog("json.data.memberInfos", json.data.memberInfos);
            setContactToDisplay([]);
            // setContacts(json.data.memberInfos);
            setAccounts(json.data.memberInfos);
            onLoad(true);
          } else {
            setContacts([]);
            setAccounts([]);
            setContactToDisplay([]);
            setContactToDisplay();
            setError(json.data.error.message);
            onLoad(false);
          }
        } else if (typeof json.data.error === "object") {
          setContacts([]);
          setAccounts([]);
          setContactToDisplay([]);
          setError(json.data.error.message);
          policyMap.delete(searchValue);
          onLoad(false);
        } else {
          setContactToDisplay([]);
          setContacts([]);
          setAccounts([]);
          setError(t("BWC.PolicyInformation.UnableToFindMember"));
          policyMap.delete(searchValue);
          onLoad(false);
        }
        setLoading(false);
      })

      //Lookup: Failed
      .catch((e) => {
        devLog("error", e);
        setLoading(false);
        setContacts([]);
        setError(t("BWC.PolicyInformation.UnableToFindMember"));
        onLoad(false);
      });
  };
  const onUserBack = (e) => {
    e.preventDefault();
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  return (
    <>
      <div className="formContainer">
        {accounts && !error ? (
          <div className="policyData">
            <div className="policyHeader">
              <h4>{t("description.ContractInformationHeader2")}</h4>
              <div style={{ fontSize: ".8rem" }}>{t("description.ContactInformationSubHeader")}</div>
              <hr />
              {accounts.map((acc, index) => {
                return (
                  <>
                    <div className="contact-list">
                      <input
                        className="vehicleSelector"
                        type="radio"
                        name="accountSelector"
                        checked={selectedAccount === acc ? true : false}
                        onClick={(e) => {
                          onSelectAccount(acc);
                        }}
                        required={true}
                      />
                      <div className="vehicle-list-item-col-1">
                        <b className="name-h5">{acc.name}</b>
                      </div>
                    </div>
                    <hr />
                  </>
                );
              })}
            </div>
          </div>
        ) : (
          <></>
        )}

        {contactToDisplay && selectedAccount ? (
          <>
            <div className="policyData">
              <div className="policyHeader">
                <h4>{t("description.SelectDriverHeader")}</h4>
                {/* <div style={{ fontSize: ".8rem" }}>Name | Policy Number</div> */}
                <hr />
                {contactToDisplay.map((con, index) => {
                  return (
                    <>
                      <div className="contact-list">
                        <input
                          className="vehicleSelector"
                          type="radio"
                          name="contactSelector"
                          checked={selectedContact === con ? "selected" : ""}
                          onClick={(e) => {
                            // setSelectedContact(con);
                            onSelectContact(con);
                          }}
                          required={true}
                        />
                        <div className="vehicle-list-item-col-1">
                          <b className="name-h5">
                            {con.firstName} {con.lastName}
                          </b>
                        </div>
                      </div>
                      <hr />
                    </>
                  );
                })}
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>

      {error ? (
        <div className="errorSection">
          <b className="error">{error}</b>
          <div>
            <button className="ui-btn" onClick={onUserBack}>
              {t("description.TryAgain")}
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
      {loading ? <PolicyLookupSpinner title={`ContractLookupTitleBWC`} message={`PolicyLookupMessage`} /> : <></>}
    </>
  );
}
